module.exports = new __parcel__URL__("PAXGLogo.814ce36e.svg").toString();